export default __webpack_public_path__ + "static/media/r.f31e2df7.png";